export const CLOUD_NAME = 'ddyktgnsx';
export const UPLOAD_PRESET_STUDY_NOTE = 'study_notes_unsigned';
export const UPLOAD_PRESET_AVATAR = 'avatar_upload';